import React from 'react';
import {usePopperTooltip} from 'react-popper-tooltip';
import 'react-popper-tooltip/dist/styles.css';

const Tooltip = ({children, tooltip, hideArrow, placement = 'bottom', wide, searchInputIcon, closeIcon, isVisible, ...props}) => {
    const {
        getArrowProps,
        getTooltipProps,
        setTooltipRef,
        setTriggerRef,
        visible,
    } = usePopperTooltip({delayShow: 400, visible: isVisible});

    return (
        <>
            <div ref={setTriggerRef} style={{display: 'inline-block'}}
                 className={searchInputIcon ? 'search-input-tooltip-styles' : ''}>
                {children}
            </div>
            {visible && (
                <div
                    ref={setTooltipRef}
                    style={{fontWeight: '300'}}
                    {...getTooltipProps({
                        className: `tooltip-container ${wide ? 'tooltip-container--wide' : ''}
                        ${closeIcon ? ' tooltip-container--close' : ''}
                        `,
                    })}
                >
                    <div {...getArrowProps({className: 'tooltip-arrow'})} />
                    {tooltip}
                </div>
            )}
        </>
    );
};

export default Tooltip;